<template>
  <button @click="onClick"
          class="mobile-navigator-map"
  >
    <app-icon icon="map"
              :is-active="isActive"
    />
  </button>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MobileNavigatorItemMap",
  computed: {
    ...mapGetters('Interface', ['isThereOpenedMenus']),

    isActive() {
      return !this.isThereOpenedMenus && this.$route.name === 'home'
    }
  },
  methods: {
    onClick() {
      this.$emit('before-toggle')
      this.closeAllMenus()
      this.$root.$emit('map.fitMap')
    },

    ...mapActions('Interface', [
      'closeAllMenus',
    ])
  }
}
</script>

<style lang="scss">
.mobile-navigator-map {
  padding: 24px !important;
}
</style>